import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Eligibility } from "../services/BronzeIncentives/bronzeIncentivesAPI.types";
import { PaymentDetailsV2 } from "../services/BronzeIncentives/bronzeIncentivesV2API.types";

type BronzeIncentive = {
  showEligibilitySliderFlag: boolean;
  awardCode: number;
  programActive: boolean;
  isEligible: boolean;
  isRestartProgram: boolean;
  isFixedPayment: boolean;
  fixedPaymentAwardCode: number;
  eligibility?: Eligibility;
  paymentDetails?: PaymentDetailsV2;
  isFetching: boolean;
};

const initialState: BronzeIncentive = {
  showEligibilitySliderFlag: false,
  awardCode: 0,
  programActive: false,
  isEligible: false,
  isRestartProgram: false,
  isFixedPayment: false,
  fixedPaymentAwardCode: 0,
  paymentDetails: {
    StartDate: 0,
    EndDate: 0,
    TotalPaymentMonths: 0,
    RemainingMonths: 0,
    AccumulatedBonus: "",
    BonusHistory: [],
    Graduated: false,
    InWindows: false,
    MostRecentAcheivedPeriod: 0,
    QualifiedCount: 0,
    Eligible: false,
  },
  isFetching: true,
};

const { actions, reducer } = createSlice({
  name: "bronzeIncentive",
  initialState,
  reducers: {
    showEligibilitySlider: (state) => ({
      ...state,
      showEligibilitySliderFlag: true,
      awardCode: state.awardCode,
    }),
    hideEligibilitySlider: (state) => ({
      ...state,
      showEligibilitySliderFlag: false,
    }),
    updateOverviewDetails: (state, action: PayloadAction<BronzeIncentive>) => ({
      ...state,
      ...action.payload,
    }),
    resetOverviewDetails: () => initialState,
  },
});

export const { showEligibilitySlider, hideEligibilitySlider, updateOverviewDetails, resetOverviewDetails } = actions;

export default reducer;
